import styled from 'styled-components';
import { TextArea } from '@thumbtack/thumbprint-react';

export const MessageSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: clamp(50%, 600px, 70%);
  margin-bottom: 30px;
`;

export const MessageSelectorTextbox = styled(TextArea)`
  width: 40%;
  height: 100%;
`;

export const MessageSelectorTemplateContainer = styled.div`
  min-width: 300px;
  /* min-height: 0px;
  max-height: 140px; */
  /* height: 250px; */
  display: flex;

  flex-direction: column;
  padding: 0 10px;
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 5px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    height: 0px;
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(0.44, rgba(122, 153, 217, 1)),
      color-stop(0.72, rgba(73, 125, 189, 1)),
      color-stop(0.86, rgba(28, 58, 148, 1))
    );
  }

  .search-box {
    background-color: white;
    border-radius: 30px;
  }
`;

export const MessageTypeSelectorContainer = styled.div`
  width: 20%;
  /* height: 100%; */
  display: flex;
  background-color: floralwhite;
  padding: 0 10px;
  margin: 0 10px;
`;

export const MessageSelectorTemplate = styled.label`
  display: block;
  width: 250px;
  margin: 5px;
  margin-right: 10px;
  border: 1px solid black;
  border-radius: 8px;
  > input {
    visibility: hidden;
    position: absolute;
  }
  > input + div {
    cursor: pointer;
    border: 2px solid transparent;

    font-size: 15px;
    font-weight: bold;
    border-radius: 7.5px;
  }

  > input:checked + div {
    background-color: #d3ffd3;
  }

  > input:not(:checked) + div {
    background-color: white;
  }
`;
